declare const VERSION: string;

export const version = VERSION;
